import { CognitoIdentityClient, GetIdCommand, GetCredentialsForIdentityCommand } from '@aws-sdk/client-cognito-identity';
import { awsRegion, Authority, IdentityPoolId } from './constants';

/**
 * Exchange the OIDC id_token from Cognito for temporary AWS credentials
 * via Cognito Federated Identity Pool.
 */
export async function getTemporaryCredentials(idToken) {
  const cognitoidentity = new CognitoIdentityClient({ region: awsRegion });
  const domain = `cognito-idp.${awsRegion}.amazonaws.com/${Authority.split('/').pop()}`;

  const logins = { [domain]: idToken };

  const idResult = await cognitoidentity.send(
    new GetIdCommand({ IdentityPoolId: IdentityPoolId, Logins: logins })
  );

  const credResult = await cognitoidentity.send(
    new GetCredentialsForIdentityCommand({
      IdentityId: idResult.IdentityId,
      Logins: logins,
    })
  );

  const c = credResult.Credentials;
  return {
    accessKeyId: c.AccessKeyId,
    secretAccessKey: c.SecretKey,
    sessionToken: c.SessionToken,
    expiration: c.Expiration,
  };
}
